import { ReactComponent as ArrowBack } from '@assets/icons/arrowBack.svg';
import { ReactComponent as ArrowForward } from '@assets/icons/arrowForward.svg';

import { Stack, StackProps, useTheme } from '@chakra-ui/react';

import { Button } from 'ui';

interface AuthStepButtonsProps extends StackProps {
  leftLabel?: string;
  rightLabel?: string;
  buttonWidth?: number;
  leftHandler?: () => void;
  onSubmit?: () => void;
  isBtnDisabled?: boolean;
}

const AuthStepButtons = ({
  leftLabel,
  rightLabel,
  leftHandler,
  isBtnDisabled = false,
  onSubmit = () => {},
  buttonWidth = 150,
  ...props
}: AuthStepButtonsProps) => {
  const {
    colors: {
      palette: {
        auth: { authStepButtons }
      }
    }
  } = useTheme();

  return (
    <Stack
      flexDirection={{ base: 'column-reverse', md: 'row' }}
      w='100%'
      justifyContent='center'
      alignItems='center'
      gap={['20px', '30px']}
      {...props}
    >
      {Boolean(leftLabel) && (
        <Button
          w={buttonWidth}
          h={45}
          leftIcon={<ArrowBack width={15} height={25} />}
          px={4}
          textTransform='uppercase'
          fontWeight='bold'
          variant='outline'
          border='1px solid'
          borderColor={authStepButtons.outlineBorder}
          onClick={leftHandler}
        >
          {leftLabel}
        </Button>
      )}
      {Boolean(rightLabel) && (
        <Button
          isDisabled={isBtnDisabled}
          onClick={onSubmit}
          w={buttonWidth}
          h={45}
          bg={authStepButtons.bg}
          rightIcon={
            <ArrowForward
              width={15}
              height={25}
              fill={authStepButtons.solidIcon}
            />
          }
          type='submit'
          px={4}
          textTransform='uppercase'
          fontWeight='bold'
        >
          {rightLabel}
        </Button>
      )}
    </Stack>
  );
};

export default AuthStepButtons;
